module.exports = __webpack_public_path__ + "img/success_payment.6f1eea63.jpeg";